import { getImageUrl } from "src/Common/common";
import { ActionMenu, ActionMenuIcon } from "src/Components/Common/ActionMenu";

const FilledOptions = ({ onDuplicate, onUnassign, onClose, canDuplicate = true, canUnassign = true }) => {
  return (
    <ActionMenu onClose={onClose}>
      {canDuplicate && (
        <ActionMenuIcon
          onClick={onDuplicate}
          title="Duplicate"
          src={getImageUrl("/images/common/white_duplicate.png")}
        />
      )}
      {canUnassign && (
        <ActionMenuIcon
          onClick={onUnassign}
          title="Unassign"
          src={getImageUrl("/images/common/white_repeat.png")}
        />
      )}
    </ActionMenu>
  );
};

export default FilledOptions;
